import React from 'react';
import QuestionsFormTable from './QuestionsFormTable';
import Question from 'records/Question';
import CardReasonFormDialog from 'components/pure/admin/CardReasonFormDialog';
import {required} from 'records/Scorecard';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import InputField from 'components/pure/utils/form/InputField';
import SelectField from 'components/pure/utils/form/SelectField';
import './ScorecardForm.styl';
import CardReasonActions from 'actions/CardReasonActions';
import {namingSchemas} from 'components/pure/admin/NamingSchemas';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class ScorecardForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showCardReasonFormDialog: false,
      questionIdx: undefined, // see showNewReasonSchemeForm
    };
    this.addQuestion = this.addQuestion.bind(this);
    this.addQuestionInputRef = this.addQuestionInputRef.bind(this);
    this.showNewReasonSchemeForm = this.showNewReasonSchemeForm.bind(this);
    this.closeCardReasonEditForm = this.closeCardReasonEditForm.bind(this);
    this.questionInputs = [];
  }

  componentDidMount() {
    this.props.scorecard.scoringScheme &&
      CardReasonActions.fetchReasonSchemesForScoringScheme.defer(
        this.props.scorecard.scoringScheme
      );
  }

  /**
   * Interrupt to show the reason scheme form to create a new reason scheme.
   *
   * We save the current question index in state so we can attach the new scheme after save.
   *
   * @param questionIdx - the ordinal index of the question we are showing the new reason scheme for
   */
  showNewReasonSchemeForm(questionIdx) {
    this.setState({showCardReasonFormDialog: true, questionIdx: questionIdx});
    this.props.CardReasonEditActions.initNewFormForScoringScheme(
      this.props.scorecard.scoringScheme
    );
  }

  /**
   * Callback from edit form
   *
   * @param optSavedReasonScheme - possible saved reason from the creation modal
   */
  closeCardReasonEditForm(optSavedReasonScheme) {
    const {questionIdx} = this.state;
    this.setState({showCardReasonFormDialog: false, questionIdx: undefined});

    if (optSavedReasonScheme) {
      // if we have a saved reason, we need to update the question's attached reason scheme
      const updatedQuestions = this.props.scorecard.questions.set(
        questionIdx,
        this.props.scorecard.questions
          .get(questionIdx)
          .set('reasonScheme', optSavedReasonScheme.id)
          .set('cardReasonSchemeId', optSavedReasonScheme.id)
      );
      this.props.onChange(this.props.scorecard.set('questions', updatedQuestions));
    }
  }

  getError(property) {
    const {scorecard} = this.props;
    return required.indexOf(property) > -1 && (scorecard[property] || '').toString().trim() === ''
      ? 'This field is required'
      : null;
  }

  onChange(field, value) {
    this.props.onChange(this.props.scorecard.set(field, value));
  }

  addQuestion() {
    const {scorecard} = this.props;
    this.props.onChange(scorecard.set('questions', scorecard.questions.push(new Question())));
    requestAnimationFrame(() => {
      const input = this.questionInputs[this.questionInputs.length - 1];
      input && input.focus();
    });
  }

  addQuestionInputRef(ref) {
    this.questionInputs.push(ref);
  }

  render() {
    const {scorecard} = this.props;

    const isEdit = scorecard.id !== null;

    return (
      <form className="scorecard-form ev-form">
        <div className="scorecard-line-container">
          <FieldContainer label="Scorecard Name:" error={this.getError('name')} errorOnBlur={true}>
            <InputField
              value={scorecard.name || ''}
              placeholder="Scorecard Name"
              focused={true}
              onChange={value => this.onChange('name', value)}
            />
          </FieldContainer>

          <FieldContainer
            label="Scoring Scheme:"
            error={this.getError('scoring')}
            errorOnBlur={true}>
            <SelectField
              disabled={isEdit}
              value={scorecard.scoringScheme}
              options={namingSchemas}
              hideResetButton={true}
              onChange={value => {
                this.onChange('scoringScheme', value);
                CardReasonActions.fetchReasonSchemesForScoringScheme(value);
              }}
            />
          </FieldContainer>
        </div>

        {scorecard.questions.size > 0 ? (
          <QuestionsFormTable
            questions={scorecard.questions}
            onChange={value => this.onChange('questions', value)}
            onSearchSkills={this.props.onSearchSkills}
            searchedSkills={this.props.searchedSkills}
            showNewReasonSchemeForm={question => this.showNewReasonSchemeForm(question)}
            searchTerm={this.props.searchTerm}
            inputRef={this.addQuestionInputRef}
          />
        ) : (
          <p>No questions have been added to this scorecard yet.</p>
        )}
        <a href="javascript:;" onClick={this.addQuestion}>
          Add a Question
        </a>

        {this.state.showCardReasonFormDialog && (
          <CardReasonFormDialog
            editStore={this.props.CardReasonEditStore}
            editActions={this.props.CardReasonEditActions}
            onRequestClose={optSavedReasonScheme =>
              this.closeCardReasonEditForm(optSavedReasonScheme)
            }
            scorecardScheme={scorecard.scoringScheme}
            questionIdx={this.state.questionIdx}
            allowChoosingReasonScheme={false}
          />
        )}
      </form>
    );
  }
}
